import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

const basePath = '/api/transport-units'
const client = new Client(getConfig().API_ENDPOINT ?? '')

export type DangerousGoodUnNumberResponse = {
  _id: string
  unNumber: string
  description: string
  unClass: number
  division: string | null
  isSupported: boolean
}

const getListOfDangerousGoodNumbers = async () => {
  return await client.get<DangerousGoodUnNumberResponse[]>(`${basePath}/api/dangerous-goods/list`)
}

export const dangerousGoodNumbersQueryOptions = queryOptions({
  queryKey: ['dangerous-goods-numbers-query-key'],
  queryFn: () => getListOfDangerousGoodNumbers(),
})
